// extracted by mini-css-extract-plugin
export default {"imageContainer":"ImageSlider_imageContainer__+jlsf","imageOverlay":"ImageSlider_imageOverlay__fVRP-"};